import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Modal from 'components/common/modal-component';
import PropTypes from 'prop-types';
import {
  SUMMARY_AI_BLOCK,
  SUMMARY_AI_BLOCK_ID,
} from 'constants/feature/statement-content-constants';
import shortid from 'shortid';
import { ReactComponent as OmniaAIIcon } from 'icons/omnia-ai.svg';
import Banner, { BANNER_TYPES } from 'components/common/banner-component';
import ReactMarkdown from 'react-markdown';
import Button, { BUTTON_TYPES } from 'components/common/button-component';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { getDocumentIndexingStatusBasedOnProcessType } from 'api/chatbot-api';
import { getStatementSummaryDetailsRequest } from 'api/statement-summary-api';
import { ROUTE_CONSTANTS } from 'constants/util/route-constants';
import { getStatementSummaryRequest } from 'api/statement-summary-api';
import {
  DOC_INDEXING_STATUS,
} from '../toolkit/chatbot-toolkit-panel/toolkit-chatbot-utils';
import { getStatementSummaryReprocessRequest } from 'api/statement-summary-api';
import { connect } from 'react-redux';
import LoadingComponent from 'components/common/loading-component';
const StatementSummaryViewerModal = ({
  onClose,
  summary,
  geoCode,
  containerCode,
  statement,
}) => {
  const REQUEST_ID = 'dummy';
  const [reprocess, setReprocess] = useState(false);
  const [summaryState, setSummaryState] = useState(false);
  const [statementSummary, setStatementSummary] = useState(summary);
  const [loading, setLoading] = useState(true);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryDetails, setSummaryDetails] = useState({})
  const urlParams = useParams();
  const [count, setCount] = useState(false);
  let fileKey = `${parseInt(statement.clientId)}_${statement.statementId}_${statement.id
    }`;
  const getSummaryStatus = async () => {
    setLoading(true);
    await getStatementSummaryDetailsRequest({ fileKey }).then((res) => {
      setLoading(false);
      let status = res.data
      setSummaryDetails(status.result)
      checkSummaryStatus(status.result);
    });

  }
  const getSummary = async () => {
    setSummaryLoading(true);
    await getStatementSummaryRequest({ revisionId: urlParams.revisionId }).then(
      (res) => {
        setSummaryLoading(false);
        setStatementSummary(res.data);
      },
    ).catch((error) => {
      setSummaryLoading(false);
    }
    );
  };
  const getIndexingStatus = async () => {
    setLoading(true);
    const response = await getDocumentIndexingStatusBasedOnProcessType(fileKey)
    setLoading(false);
    const { status, retryCount , retryThreshold} = response.result;
    setSummaryDetails(response.result)
    if (status === DOC_INDEXING_STATUS.COMPLETED) {
      await getSummaryStatus();
    }
    else if (status === DOC_INDEXING_STATUS.IN_PROGRESS) {
      setReprocess(true);
      setSummaryState(false);
      setLoading(false);
    }
    else if (status === DOC_INDEXING_STATUS.FAILED || status === DOC_INDEXING_STATUS.NOT_STARTED) {
      if (retryCount >= retryThreshold) {
        setCount(true);
      }
      else {
        setReprocess(false);
        setSummaryState(false);
      }
    }

  }
  const checkSummaryStatus = async (summaryStatus) => {
    if (summaryStatus) {
      if (summaryStatus?.status === DOC_INDEXING_STATUS.COMPLETED) {
        setReprocess(false);
        setSummaryState(true);
        await getSummary();
      } else if (summaryStatus?.status === DOC_INDEXING_STATUS.FAILED || summaryStatus?.status === DOC_INDEXING_STATUS.NOT_STARTED || summaryStatus?.status===DOC_INDEXING_STATUS.COMPLETED_WITH_ERROR) {
        if (summaryStatus?.retryCount >=summaryStatus?.retryThreshold) {
          setCount(true);
        }
        setReprocess(false);
        setSummaryState(false);
      } else if (summaryStatus?.status === DOC_INDEXING_STATUS.IN_PROGRESS) {
        setReprocess(true);
        setSummaryState(false);
      }
    }
  }
  useEffect(() => {
    if (statementSummary !== '') {setLoading(false);setSummaryState(true);}
    if (statementSummary === '') {
      getIndexingStatus();
    }
  }, []);

  const SUPPORT_REQUEST_ANCHOR = (
    <a
      href={ROUTE_CONSTANTS.SUPPORT_REQUEST_SUMMARY}
      target={'_blank'}
      rel="noopener noreferrer"
    >
      <FormattedMessage id={'statement-summary-viewer-support-request'} />
    </a>
  );
  const displayReprocessBanner = (content, bannerType) => {
    return (
      <Banner
        width={'100%'}
        id={`${SUMMARY_AI_BLOCK_ID}_warning-guidance`}
        type={bannerType}
        bannerCopy={{
          id: content,
          values: {
            b: (...chunks) => <strong>{chunks}</strong>,
            lineBreak: <br key={`-brTag-${shortid.generate()}}`} />,
          },
        }}
        isInternationalized
      />
    );
  };
  const handleReprocess = async () => {
    setReprocess(!reprocess);
    let reprocessData = {
      fileKey: fileKey,
      geoCode: geoCode,
      retryCount: summaryDetails.retryCount,
      containerCode: containerCode,
      requestId: REQUEST_ID,
    };
    await getStatementSummaryReprocessRequest(reprocessData);
  };
  return (
    <Modal
      id={`${SUMMARY_AI_BLOCK_ID}-statement-summary-modal`}
      onClose={onClose}
      title={'global-header-statement-summary.button'}
      icon={<OmniaAIIcon />}
      className={`${SUMMARY_AI_BLOCK}__modal`}
    >
      {loading ? (<LoadingComponent></LoadingComponent>) :
        (
          <>
            {summaryState && !reprocess && (
              <>
                {displayReprocessBanner(
                  'statement-summary-viewer-modal-banner',
                  BANNER_TYPES.INFORMATION,
                )}
                <div className={`${SUMMARY_AI_BLOCK}__modal--summary`}>
                  {summaryLoading ? (<LoadingComponent></LoadingComponent>) : <ReactMarkdown>{statementSummary.response}</ReactMarkdown>}
                </div>
              </>
            )}
            {!summaryState && !count && (
              <>
                {!reprocess &&
                  !count &&
                  displayReprocessBanner(
                    'statement-summary-viewer-summary-fail-banner',
                    BANNER_TYPES.ERROR,
                  )}
                {reprocess &&
                  !count &&
                  displayReprocessBanner(
                    'statement-summary-viewer-summary-reprocess-banner',
                    BANNER_TYPES.INFORMATION,
                  )}
                <div
                  className={`${SUMMARY_AI_BLOCK}__modal--reprocess-button-container`}
                >
                  <Button
                    type={BUTTON_TYPES.primary}
                    id={`${SUMMARY_AI_BLOCK_ID}__reprocess_button`}
                    className={`${SUMMARY_AI_BLOCK}__modal--reprocess-button`}
                    disabled={reprocess}
                    onClick={handleReprocess}
                  >
                    <FormattedMessage
                      id={'statement-summary-viewer-reprocess-button'}
                    />
                  </Button>
                </div>
              </>
            )}
            {count && (
              <FormattedMessage
                id={'statement-summary-viewer-summary-support-message'}
                values={{
                  link: SUPPORT_REQUEST_ANCHOR,
                }}
              />
            )}
          </>
        )}
    </Modal>
  );
};
StatementSummaryViewerModal.propTypes = {
  /** Modal panel onClose function  */
  onClose: PropTypes.func.isRequired,
  /** Summary from genAI */
  summary: PropTypes.object,
  /** summary details regarding reprocessing */
  summaryDetails: PropTypes.object,
  /** indexing status of the statement */
  indexingStatus: PropTypes.object,
};
const mapStateToProps = ({
  data: {
    selectedProject: {
      project: { geoCode, containerCode },
    },
    revision,
  },
}) => ({
  geoCode,
  containerCode,
  statement: revision,
});

export default connect(mapStateToProps, null)(StatementSummaryViewerModal);
